module.exports = __webpack_public_path__ + "static/infographic-ampm@2x-dd43e24f992038c0e8b913a06db1a81f.png";